import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=6415faca&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=6415faca&prod&scoped=true&lang=css"
import style1 from "./Config.vue?vue&type=style&index=1&id=6415faca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6415faca",
  null
  
)

export default component.exports